import * as React from 'react';
import styled from '@emotion/styled';

export interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
  size?: 'md' | 'lg';
}

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const Native = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const Thumb = styled.span`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  transition: transform ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.ease};
`;

const Track = styled.span<{ $lg?: boolean }>`
  width: ${({ $lg }) => ($lg ? '40px' : '32px')};
  height: ${({ $lg }) => ($lg ? '22px' : '18px')};
  border-radius: 999px;
  background: ${({ theme }) => theme.color.slate[300]};
  position: relative;
  flex-shrink: 0;
  transition: background ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.ease};

  ${Thumb} { width: ${({ $lg }) => ($lg ? '18px' : '14px')}; height: ${({ $lg }) => ($lg ? '18px' : '14px')}; }
  ${Native}:checked + & { background: ${({ theme }) => theme.color.primary.base}; }
  ${Native}:checked + & ${Thumb} { transform: translateX(${({ $lg }) => ($lg ? '18px' : '14px')}); }
  ${Native}:focus-visible + & { box-shadow: 0 0 0 3px ${({ theme }) => theme.color.blue[100]}; }
`;

/** Lumen switch — a single setting that applies immediately. */
export function Switch({ label, size = 'md', children, ...rest }: SwitchProps) {
  return (
    <Label>
      <Native type="checkbox" {...rest} />
      <Track $lg={size === 'lg'}><Thumb /></Track>
      {label ?? children}
    </Label>
  );
}
